import { z } from "zod";
import { CommunityAuthor, CommunityKudosRecipient } from "./author.js";
import { CommunityKudosCategory, CommunityKudosStatus } from "./enums.js";
import { CommunityReactionSummary } from "./reaction.js";
import { CommunityPreferences } from "./settings.js";
export const CommunityKudosFeedItem = z.object({
    id: z.string().uuid(),
    type: z.literal("kudos"),
    status: CommunityKudosStatus,
    sender: CommunityAuthor,
    recipients: z.array(CommunityKudosRecipient),
    category: CommunityKudosCategory,
    note: z.string().nullable(),
    createdAt: z.string(),
    publishedAt: z.string().nullable(),
    reactions: z.array(CommunityReactionSummary),
    reportCount: z.number().int().nonnegative().default(0),
});
export const SendCommunityKudosRequest = z.object({
    recipientUserIds: z.array(z.string().uuid()).min(1).max(10),
    category: CommunityKudosCategory,
    note: z.string().trim().max(1200).optional(),
    shareToCommunity: z.boolean().optional(),
    enablePublicKudosSharing: z.boolean().optional(),
    sourcePostId: z.string().uuid().nullable().optional(),
});
export const SendCommunityKudosResponse = z.object({
    item: CommunityKudosFeedItem.nullable(),
    kudosId: z.string().uuid(),
    preferences: CommunityPreferences,
});
//# sourceMappingURL=kudos.js.map